// extracted by mini-css-extract-plugin
export default {"root":"RGpql","buttons":"LcK0J","vertical":"lg_Ek","horizontal":"l6ZTy","benefits":"aKXXC","title":"o1Xnp","mobile":"Q7p2y","smallMobile":"nOQZp"};